import { h, createContext } from "preact";
import { useState } from "preact/hooks";
import ViralPopup from "./ViralPopup";
import {
  calculateForeground,
  traceWidgetLoad
} from "../../internal_utilities/utilities";

export const ViralReferralWidgetContext = createContext("");

const ViralReferral = ({
  renderConfig,
  currentLanguage,
  dataPosition,
  currentCampaign
}) => {
  const [isPopupOpened, setIsPopupOpened] = useState(false);

  const [viewStateHistory, setViewStateHistory] = useState([
    {
      view: "offer-view",
      params: ""
    }
  ]);
  const removeFromViewStateHistory = () => {
    let tempViewStateHistory = viewStateHistory;
    tempViewStateHistory.pop();
    setViewStateHistory([...tempViewStateHistory]);
  };
  const addToViewStateHistory = (view, params) => {
    let tempViewStateHistory = viewStateHistory;
    tempViewStateHistory.push({
      view: view,
      params: params
    });
    if (tempViewStateHistory.length > 5) tempViewStateHistory.shift();
    setViewStateHistory([...tempViewStateHistory]);
  };

  const viralReferralWidgetContextValues = {
    viewStateHistory: {
      currentView: viewStateHistory[viewStateHistory.length - 1],
      goBack: removeFromViewStateHistory,
      goTo: addToViewStateHistory
    },
    isPopupOpened: { get: isPopupOpened, set: setIsPopupOpened },
    currentLanguage: currentLanguage,
    widgetConfig: renderConfig.config.widgetConfig,
    referral: renderConfig.config.referral,
    currentCampaign: currentCampaign
  };

  const wordReplacer = sourceText => {
    const rewardStagesArray = viralReferralWidgetContextValues.currentCampaign.rewardStage.sort(
      (a, b) => a.rewardTarget - b.rewardTarget
    );

    const offerViewTitleWordMap = [
      {
        placeholder: "<gift_offer>",
        value: `${viralReferralWidgetContextValues.currentCampaign.giftConfig
          .discountValue * -1}${
          viralReferralWidgetContextValues.currentCampaign.giftConfig
            .discountType === "percentage"
            ? "%"
            : window.Shopify.currency.active
        }`
      },
      {
        placeholder: "<maximum_reward>",
        value: `${rewardStagesArray[rewardStagesArray.length - 1].discountConfig
          .discountValue * -1}${
          rewardStagesArray[rewardStagesArray.length - 1].discountConfig
            .discountType === "percentage"
            ? "%"
            : window.Shopify.currency.active
        }`
      }
    ];
    let text = sourceText;
    offerViewTitleWordMap.map(item => {
      text = text.replace(item.placeholder, item.value);
    });
    return text;
  };

  if (
    renderConfig &&
    viralReferralWidgetContextValues.currentCampaign &&
    viralReferralWidgetContextValues.currentCampaign.thankyouPageConfig
      .widgetPosition === dataPosition
  )
    return (
      <ViralReferralWidgetContext.Provider
        value={viralReferralWidgetContextValues}
      >
        <style>
          {viralReferralWidgetContextValues.currentCampaign.thankyouPageConfig
            .widgetCustomCss &&
            viralReferralWidgetContextValues.currentCampaign.thankyouPageConfig
              .widgetCustomCss}
        </style>
        <div className="corner-midas-widget">
          <div
            id="corner-thank-offer-card"
            ref={node => {
              if (node)
                node.style.setProperty(
                  "background",
                  `linear-gradient(${
                    viralReferralWidgetContextValues.currentCampaign
                      .thankyouPageConfig.bgStartColor
                  } 0%, ${
                    viralReferralWidgetContextValues.currentCampaign
                      .thankyouPageConfig.bgEndColor
                  }  100%)`
                );
            }}
            className="bg-white rounded-lg shadow-lg my-2 p-6"
          >
            <div id="corner-thank-card-icon" className="w-10 mb-4 ">
              {viralReferralWidgetContextValues.currentCampaign
                .thankyouPageConfig.fgColor === "light" ? (
                  <img
                    src={
                    "https://assets.cornercart.io/images/corner-widget/offer-selected-light.svg"
                  }
                    alt="Cart"
                />
              ) : (
                <img
                  src={
                    "https://assets.cornercart.io/images/corner-widget/offer-selected-dark.svg"
                  }
                  alt="Cart"
                />
              )}
            </div>
            <div id="corner-offer-card-info">
              <div
                id="corner-initial-text"
                ref={node => {
                  if (node)
                    node.style.setProperty(
                      "color",
                      `${
                        viralReferralWidgetContextValues.currentCampaign
                          .thankyouPageConfig.fgColor === "light"
                          ? "rgba(255,255,255,1)"
                          : "rgba(0,0,0,.8)"
                      }`
                    );
                }}
                className="text-base font-medium my-2"
              >
                {viralReferralWidgetContextValues.currentLanguage &&
                viralReferralWidgetContextValues.currentLanguage
                  .thank_widget_line1
                  ? wordReplacer(
                      viralReferralWidgetContextValues.currentLanguage
                        .thank_widget_line1
                    )
                  : wordReplacer("Gift your friends <gift_offer> discount &")}
              </div>
              <div
                id="corner-main-text"
                ref={node => {
                  if (node)
                    node.style.setProperty(
                      "color",
                      `${
                        viralReferralWidgetContextValues.currentCampaign
                          .thankyouPageConfig.fgColor === "light"
                          ? "rgba(255,255,255,1)"
                          : "rgba(0,0,0,.8)"
                      }`
                    );
                }}
                className=" text-xl font-bold my-2"
              >
                {viralReferralWidgetContextValues.currentLanguage &&
                viralReferralWidgetContextValues.currentLanguage
                  .thank_widget_offer_line2
                  ? wordReplacer(
                      viralReferralWidgetContextValues.currentLanguage
                        .thank_widget_offer_line2
                    )
                  : wordReplacer(
                      "Get discout coupon worth upto <maximum_reward>"
                    )}
              </div>
              <div className="flex ">
                <button
                  id="corner-thank-cta"
                  ref={node => {
                    if (node)
                      node.style.setProperty(
                        "background",
                        `${
                          viralReferralWidgetContextValues.currentCampaign
                            .thankyouPageConfig.ctaColor
                        }`
                      );
                  }}
                  className="px-3 py-4 rounded-lg mt-3 text-base shadow-lg"
                  onClick={() => {
                    traceWidgetLoad({
                      name: "clicked_initial_cta",
                      domain: window.Shopify.shop,
                      url: window.location.href,
                      referrer: document.referrer || "",
                      key: ["app_name", "widget_type"],
                      value: [
                        "offerscorner",
                        viralReferralWidgetContextValues.currentCampaign.type
                      ],
                      operatingSystem: window.navigator.userAgentData
                        ? window.navigator.userAgentData.platform
                        : window.navigator.platform,
                      screenSize: window.screen
                        ? `${window.screen.width}-${window.screen.height}`
                        : "",
                      browserVersion: window.navigator.userAgentData
                        ? window.navigator.userAgentData.brands[0].version
                        : "",
                      browser: window.navigator.userAgentData
                        ? window.navigator.userAgentData.brands[0].brand
                        : ""
                    });
                    setIsPopupOpened(true);
                  }}
                >
                  <span
                    ref={node => {
                      if (node)
                        node.style.setProperty(
                          "color",
                          `${
                            calculateForeground(
                              viralReferralWidgetContextValues.currentCampaign
                                .thankyouPageConfig.ctaColor
                            ) === "white"
                              ? "rgba(255,255,255,1)"
                              : "rgba(0,0,0,.8)"
                          }`
                        );
                    }}
                  >
                    {viralReferralWidgetContextValues.currentLanguage &&
                    viralReferralWidgetContextValues.currentLanguage
                      .thank_widget_cta
                      ? viralReferralWidgetContextValues.currentLanguage
                          .thank_widget_cta
                      : "Get This"}
                  </span>
                </button>
              </div>
            </div>
          </div>
          {isPopupOpened && <ViralPopup />}
        </div>
      </ViralReferralWidgetContext.Provider>
    );
};

export default ViralReferral;
